import React, { Fragment } from 'react';
import useTranslation from '../../../Hooks/UseTranslation';

type Props = {
    isNotRead: boolean,
    icon: any,
    data: any,
    onClick: any,
    timeDifference: string
    action: any
}

const AssistantProfileNotification = (props: Props) => {

    const { t, language } = useTranslation()

    return (
        <div className={`${props.isNotRead ? 'dropdownnotification' : ''} dropdown-item d-flex`}
            onClick={props.onClick}
        >
            <div className="notification-icon" style={{ padding: '10px' }}>
                {props.icon}
            </div>
            <div className="notification-details flex-grow-1">
                <p className="m-0 d-flex align-items-center">
                    <span>
                        {t('NOTIFICATIONS_ASSISTANT_PROFILE:Project')}{' '}
                        <strong>{props.data.project.name}</strong>
                    </span>
                    <span
                        className={`badge badge-pill badge-muted ml-1 mr-1`}
                    >
                        {props.data.status === 'read' ? null : (
                            <span className="badge badge-pill badge-primary ml-1 mr-1">
                                {t('NOTIFICATIONS_ASSISTANT_PROFILE:Pending')}
                            </span>
                        )}
                    </span>
                    <span className="flex-grow-1"></span>
                    <span className=" text-muted ml-auto">
                        {language === 'es' && (
                            <Fragment>
                                {t('NOTIFICATIONS_ASSISTANT_PROFILE:Ago')}{' '}
                                {props.timeDifference}
                            </Fragment>
                        )}
                        {language === 'en' && (
                            <Fragment>
                                {props.timeDifference}{' '}
                                {t('NOTIFICATIONS_ASSISTANT_PROFILE:Ago')}
                            </Fragment>
                        )}
                    </span>
                </p>
                <p className=" text-muted m-0">
                    <span className='notification-content'>
                        {props.action === 'assigned' && (
                            <span>
                                <strong>
                                    {props.data.userFrom.name} {props.data.userFrom.surname}
                                </strong>{' '}
                                {t('NOTIFICATIONS_ASSISTANT_PROFILE:HasAssignedYouAs')}{' '}
                                <strong>
                                    {t('NOTIFICATIONS_ASSISTANT_PROFILE:Pl4nnerAssistant')}
                                </strong>
                            </span>

                        )}
                        {props.action === 'removed' && (
                            <span>
                                {t('NOTIFICATIONS_ASSISTANT_PROFILE:YouHaveBeenRemovedAs')}{' '}
                                <strong>
                                    {t('NOTIFICATIONS_ASSISTANT_PROFILE:Pl4nnerAssistant')}
                                </strong>
                            </span>
                        )}
                        en{' '}
                        <strong>{props.data.project.name}</strong>
                    </span>
                </p>
            </div>
        </div>
    )
}

export default AssistantProfileNotification